// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project imports
import Logo from './Logo';
import Profile from './Profile';
import Notification from './Notification';
import Basket from './Basket';
import MobileSection from './MobileSection';


// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <>
      {downLG && <Logo />}
      <Box 
        sx={{
          ml: 'auto',
          display: 'flex',
          width: downLG ? '15vw' : '6vw'
        }}
      >
        <Basket />
        <Notification/>
        {!downLG && <Profile />}
      </Box>
      {downLG && <MobileSection />}
    </>
  );
}
